import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2 } from '@/api/model/interfaces';

export default class PackageKS2Odata extends OdataManager<PackageKS2> {}
